export default __webpack_public_path__ + "static/media/bos.6362318a.png";